import { Client } from "../models/ByClients/Client";
import { Item } from "../models/ByClients/Item";

export default function (id: string, clients: Client[]): Item | null {
  try {
    clients.forEach((item) => {
      if (!Array.isArray(item.children)) {
        return;
      }

      const searchedValue = item.children.find((entity) => entity.id === id);

      if (searchedValue) {
        throw searchedValue;
      }
    });
  } catch (e) {
    return e;
  }

  return null;
}
